export default {
  title: "验证您的邮箱",
  verifying: {
    title: "正在验证您的邮箱",
    subtitle: "请稍候，我们正在验证您的邮箱地址...",
  },
  sending: {
    title: "正在发送验证邮件",
    subtitle: "请稍候，我们正在发送验证邮件...",
  },
  sent: {
    title: "验证邮件已发送",
    confirmationMessage: {
      beforeEmail: "我们已向 ",
      afterEmail: " 发送确认链接",
    },
    instruction: "请检查您的收件箱并点击链接以激活您的账户",
    troubleMessage: "没有收到邮件？请检查您的垃圾邮件文件夹或点击下方“重新发送”",
    limitNote: "注意：您每天最多可以重新发送验证邮件3次",
  },
  resent: {
    title: "验证邮件已重新发送",
    confirmationMessage: {
      beforeEmail: "我们已向 ",
      afterEmail: " 重新发送确认链接",
    },
    instruction: "请检查您的收件箱并点击链接以激活您的账户",
    troubleMessage: "如果仍未收到，请检查垃圾邮件/垃圾文件夹或稍后再试",
    limitNote: "注意：您每天最多可以重新发送验证邮件3次",
  },
  success: {
    title: "邮箱验证成功",
    subtitle: "您的邮箱已通过验证。现在可以登录您的账户。",
    button: "前往登录",
    autoRedirectMessage: "{seconds}秒后自动跳转到仪表板...",
  },
  error: {
    title: "邮箱验证失败",
    subtitle: "验证过程中发生错误。请稍后再试。",
    button: "返回登录",
  },
  resending: "重新发送中...",
  resendAvailableIn: "{seconds}秒后可重新发送",
  resendVerificationEmail: "重新发送验证邮件",
  verificationFailed: "邮箱验证失败",
  verificationError: "邮箱验证过程中发生错误",
  pleaseWait: "请等待{seconds}秒后再重新发送",
  dailyLimitReached: "已达到每日重新发送限制。请明天再试。",
  resentSuccess: "验证邮件重新发送成功",
  resendFailed: "重新发送验证邮件失败",
  invalidRequest: "无效请求",
  remainingAttempts: "您今天还有{count}次尝试机会",
};
